import type { IncidentFile } from '@piccolohealth/pbs-common';
import { ChakraV3 } from '@piccolohealth/ui';
import React from 'react';
import { FaCaretDown, FaPencilAlt, FaRegTrashAlt } from 'react-icons/fa';
import { showModal } from '../../components/generic/Modal';
import { IncidentFileDeleteModal } from './IncidentFileDeleteModal';
import { IncidentFileEditModal } from './IncidentFileEditModal';

interface Props extends ChakraV3.ButtonProps {
  file: IncidentFile;
}

export const IncidentFileActionMenu = (props: Props) => {
  const { file, ...rest } = props;

  return (
    <ChakraV3.Menu.Root lazyMount={true} unmountOnExit={false} size='sm'>
      <ChakraV3.Menu.Positioner>
        <ChakraV3.Menu.Content>
          <ChakraV3.MenuItem
            onClick={() =>
              showModal(IncidentFileEditModal, {
                incidentFile: file,
              })
            }
            value='edit'
          >
            <FaPencilAlt />
            Edit
          </ChakraV3.MenuItem>
          <ChakraV3.MenuItem
            onClick={() =>
              showModal(IncidentFileDeleteModal, {
                incidentId: file.incidentId,
                incidentFileId: file.id,
                incidentFileName: file.name,
              })
            }
            value='delete'
            color='danger'
          >
            <FaRegTrashAlt />
            Delete
          </ChakraV3.MenuItem>
        </ChakraV3.Menu.Content>
      </ChakraV3.Menu.Positioner>
      <ChakraV3.Menu.Trigger asChild>
        <ChakraV3.Button variant='plain' size='sm' {...rest}>
          Actions
          <FaCaretDown />
        </ChakraV3.Button>
      </ChakraV3.Menu.Trigger>
    </ChakraV3.Menu.Root>
  );
};
